<template>
  <div>
    <v-select
      v-if="field.type === 'select' && field.key==='payment_handler.withdraw.hold_time'"
      :key="`select-${field.key}`"
      class="mb-2"
      :label="field.label"
      v-model="item[field.key]"
      :items="holdTimeList"
      :loading="loading"
      :disabled="disabled"
      hide-details
      required
    />
    <v-select
      v-else-if="field.type === 'select' && field.choices"
      :key="`select-choices-${field.key}`"
      class="mb-2"
      :label="field.label"
      v-model="item[field.key]"
      :items="field.choices"
      item-value="value"
      item-text="text"
      :loading="loading"
      :disabled="disabled"
      hide-details
      clearable
    />
    <v-switch
      v-else-if="field.type === 'boolean'"
      :key="`bool-${field.key}`"
      class="mb-2"
      :label="field.label"
      v-model="item[field.key]"
      :loading="loading"
      :disabled="disabled"
      hide-details
    />
    <v-text-field
      v-else-if="field.type === 'number'"
      :key="`number-${field.key}`"
      class="mb-2"
      :label="field.label"
      v-model.number="item[field.key]"
      type="number"
      :loading="loading"
      :disabled="disabled"
      hide-details
      required
    />
    <div
      v-else-if="field.type === 'json'"
      class="mt-4"
      :key="`json-${field.key}`"
    >
      <v-label
        v-text="field.label"
      />
      <vue-json-editor
        :value="item[field.key] ?? {}"
        mode="code"
        :modes="[]"
        :show-btns="false"
        expanded-on-start
      />
      <non-ascii-alert :source-object="item[field.key] ?? {}" />
    </div>
    <v-select
      v-else-if="field.type === 'country'"
      v-model="item[field.key]"
      multiple
      append-icon="flag"
      item-value="code"
      item-text="title"
      :label="field.label"
      :items="$store.state.app.countries"
      :key="`country-${field.key}`"
    />
    <duration-input
      v-else-if="field.type === 'duration'"
      v-model.number="item[field.key]"
      :label="field.label"
      persistent-hint
      :key="`duration-${field.key}`"
    />
    <v-combobox
      v-else-if="field.type === 'combobox'"
      v-model="item[field.key]"
      :label="field.label"
      :items="field.choices"
      :key="`combo-${field.key}`"
      :loading="loading"
      multiple
      hide-details
    />
    <v-autocomplete
      v-else-if="field.type === 'autocomplete'"
      v-model="item[field.key]"
      :label="field.label"
      :items="field.choices"
      :key="`autocomplete-${field.key}`"
      :loading="loading"
      multiple
      hide-details
    />
    <v-text-field
      v-else
      :key="field.key"
      class="mb-2"
      :label="field.label"
      v-model="item[field.key]"
      :loading="loading"
      :disabled="disabled"
      hide-details
      required
    />
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor'
import DurationInput from '@/components/core/DurationInput.vue'
import NonAsciiAlert from '../NonAsciiAlert.vue'

export default {
  name: 'FieldRenderer',
  components: {
    vueJsonEditor,
    NonAsciiAlert,
    DurationInput,
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    holdTimeList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

